export default {
  processor: (session, approve, reject, enabled) => {
    if (enabled && session.loggedIn === false) {
      reject('You are unauthorised to view this area.');
    }

    approve();
  },
};
